import Navigation from '../components/Navigation/Navigation'
import FileItem from '../components/FileItem/FileItem'
import Sidebar from '../components/Sidebar/Sidebar'
import { mockFiles } from '../data/mockData'
import layoutStyles from '../styles/layout.module.css'
import cardStyles from '../styles/card.module.css'
import fileItemStyles from '../components/FileItem/FileItem.module.css'

export default function FilesPage() {
  return (
    <div className={layoutStyles.mainLayout}>
      <Sidebar activeItem="other" />
      
      <div className={layoutStyles.mainContentWrapper}>
        <Navigation />
        <main className={layoutStyles.mainContent}>
          <div className={layoutStyles.container}>
            <div className={cardStyles.card}>
              <div className={cardStyles.cardHeader}>
                <h1 className={cardStyles.cardTitle}>All Files</h1>
              </div>
              <div className={fileItemStyles.fileList}>
                {mockFiles.map(file => (
                  <FileItem
                    key={file.id}
                    name={file.name}
                    type={file.type}
                    size={file.size}
                    uploadedAt={file.uploadedAt}
                    source={file.source}
                  />
                ))}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}
